/** Parse CSV text preserving original string values (no xlsx date coercion). */
export function parseCsvText(text: string): string[][] {
    const lines = text.trim().split('\n');
    return lines.map((line) => {
        const cells: string[] = [];
        let current = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
            const ch = line[i];
            if (ch === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    current += '"';
                    i++;
                } else {
                    inQuotes = !inQuotes;
                }
            } else if (ch === ',' && !inQuotes) {
                cells.push(current);
                current = '';
            } else if (ch !== '\r') {
                current += ch;
            }
        }
        cells.push(current);
        return cells;
    });
}
